<template>
  <div class="competence-skills">
    <transition name="slide" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'competence-skills-view'
}
</script>

<style lang="scss" scoped>

</style>
